module.exports = __webpack_public_path__ + "img/leafy_tree.d788a811.svg";